import a from"./fails.js";import e from"./global.js";var o=a,p=e,g=p.RegExp,l=o(function(){var r=g("(?<a>b)","g");return r.exec("b").groups.a!=="b"||"b".replace(r,"$<a>c")!=="bc"});export{l as default};
